module.exports = __webpack_public_path__ + "media/img/decorations/course-outline-img2-c0200e7b7f8e6ebc3e46fe0c07e40175.svg";